import 'core-js/proposals/reflect-metadata';

import { Serializable, jsonProperty } from 'ts-serializable';

class UserAddress extends Serializable{

    @jsonProperty(String, null)
    logradouro: string | null = '';

    @jsonProperty(String, null)
    numero: string | null = '';

    @jsonProperty(String, null)
    complemento: string | null = '';

    @jsonProperty(String, null)
    bairro: string | null = '';

    @jsonProperty(String, null)
    cidade: string | null = '';

    @jsonProperty(String, null)
    estado: string | null = '';

    @jsonProperty(String, null)
    cep: string | null = '';
}

export default UserAddress;